import React from "react";
import logo from "../../Assets/logo-pos.png";

export const BizXPos = () => {
  return <img
    style={{ height: 35, pointerEvents: "none" }}
    src={logo}
    alt="logo"
  />
};